<template>
    <section class="l-section l-section--main">
        <div
            class="l-container l-container--main l-container--horizontalPaddings"
        >
            <div class="l-row l-row--center">
                <div class="l-row__column l-row__column--7">
                    <h1 class="a-title">Podaj swoje dane</h1>
                    <form
                        class="a-mobile o-form"
                        @submit.prevent="handleSubmit"
                    >
                        <div class="a-control o-form__group">
                            <label
                                class="a-label a-control__label"
                                for="userLogin"
                            >
                                Nazwa użytkownika
                            </label>
                            <input
                                id="userLogin"
                                class="a-control__input"
                                type="email"
                                v-model="email"
                                autocomplete="username"
                            />
                        </div>
                        <div class="a-control o-form__group">
                            <label
                                class="a-label a-control__label"
                                for="userPassword"
                                >Hasło</label
                            >
                            <input
                                id="userPassword"
                                class="a-control__input"
                                v-model="password"
                                type="password"
                                autocomplete="current-password"
                            />
                        </div>
                        <p class="a-text o-form__text">
                            Nie pamiętasz hasła?
                            <router-link
                                class="a-text--bold a-link"
                                :to="{ name: 'dashboard-reset-password-step1' }"
                            >Kliknij</router-link>
                            , aby przypomnieć!
                        </p>
                        <div class="o-form__buttons">
                            <div class="a-mobile__buttons">
                                <a-button
                                    class="a-button a-button--primary a-button--mobileFullWidth"
                                    :is-processing="authStatus === 'pending'"
                                    type="submit"
                                >
                                    Zaloguj
                                    <a-icon class="a-button__icon" icon="Right"/>
                                </a-button>
                            </div>
                        </div>
                        <o-notifications
                            :is-static="true"
                            name="dashboard-login"
                        />
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            email: (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_EMAIL) ? process.env.VUE_APP_EMAIL : '',
            password: (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_PASS) ? process.env.VUE_APP_PASS : ''
        }
    },
    computed: {
        authStatus() {
            return this.$store.getters['users/status']
        }
    },
    methods: {
        handleSubmit() {
            this.$store.dispatch('users/login', {
                email: this.email,
                password: this.password
            }).then(() => {
                this.$router.push({ name: 'dashboard-summary' })
            }).catch(error => {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Podano nieprawidłowy email lub hasło - spróbuj ponownie lub skontaktuj się z BOK.',
                    limit: 0,
                    name: 'dashboard-login'
                })
                // if not wrong authorization data then errorlog
                if(error.response && error.response.status !== 401) {
                    console.error(error)
                }
            })
        }
    }
}
</script>
